<section class="p-4 rounded-lg bg-white shadow-sm dark:bg-gray-800">
  <h2 class="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">No evento</h2>


  <app-teclado-numerico
    placeholder="No. evento SGP"
    (change)="onChangeTN($event)"
    (confirmValue)="confirmar($event)">
  </app-teclado-numerico>
</section>
